import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { EnvioAduanasService } from './envioaduana.service';
import { HttpParams } from '@angular/common/http';
import { EnvioAduanasItemResultsViewModel, EnvioAduanasItemViewModel, EnvioAduanasViewModel } from './envioaduana.types';
import { ConfirmationService } from 'primeng/api';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { Tc } from '../../../core/_infrastructure/types/common';
import { DatePipe } from '@angular/common';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { Table } from 'primeng/table';

@Component({
    selector: 'app-envioaduana-list',
    templateUrl: './envioaduana-list.component.html',
})
export class EnvioAduanaListComponent extends ComponentBase implements OnInit {
    @ViewChild('tableSearch') turboTable: Table;

    resultEnvioAduanas: EnvioAduanasItemResultsViewModel;
    listEstadoEnvio: Tc[];
    firstDayMonth: Date;
    lastDayMonth: Date;
    cols: any[];

    visibilitySpinner = false;
    public isCollapsed = false;

    constructor(
        public datepipe: DatePipe,
        private router: Router,
        private fb: FormBuilder,
        private globalService: GlobalService,
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private confirmationService: ConfirmationService,
        private envioAduanasService: EnvioAduanasService,
    ) {
        super(authService, notificacionService, exceptionHandler);

        this.resultEnvioAduanas = new EnvioAduanasItemResultsViewModel();
    }

    ngOnInit() {
        this.cols = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'IdSolicitud', header: 'Id Solicitud' },
            { field: 'FechaInicio', header: 'FechaInicioDatetime', display: 'none' }, //tipo Datetime
            { field: 'FechaEnvio', header: 'FechaEnvioDatetime', display: 'none' }, //tipo Datetime
            { field: 'FechaInicioCompleta', header: 'Fecha Inicio' },
            { field: 'FechaCompleta', header: 'Fecha Envío' }, // | date:'dd/MM/yyyy' tipo string
            { field: 'Duracionms', header: 'Duración (ms)' },
            { field: 'CodigoSolicitud', header: 'Código Solicitud' },
            { field: 'CodigoTaric', header: 'Código TARIC' },
            { field: 'NRC', header: 'Nº Autorización' },
            { field: 'EstadoEnvioAduanas', header: 'Estado Envío' },
            { field: 'Respuesta', header: 'Respuesta' },
        ];

        this.globalService.getEnvioAduanas().subscribe(res => {
            this.listEstadoEnvio = res;
        });

        this.firstDayMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        //this.firstDayMonth = this.datepipe.transform(dateTemp, 'yyyy-MM-dd');
        let temp = new Date().getMonth() + 1;
        this.lastDayMonth = new Date(new Date(new Date().getFullYear(), temp, 1).getTime() - 0.001 * 60 * 60 * 24);
        //this.lastDayMonth = this.datepipe.transform(dateTemp2, 'yyyy-MM-dd');

        this.form = this.fb.group({
            IdSolicitud: null,
            CodigoSolicitud: '',
            CodigoTaric: '',
            IdEstadoEnvioAduanas: null,
            Nrc: '',
            //FechaDesde: new Date(dateTemp),
            FechaDesde: this.firstDayMonth,
            FechaHasta: this.lastDayMonth,
            //FechaEnvio: null
        });

        this.loadBack();
    }

    loadBack() {
        if (
            this.envioAduanasService.currentFilterEnvioAduana.FechaDesde == null ||
            this.envioAduanasService.currentFilterEnvioAduana.FechaHasta == null ||
            this.envioAduanasService.currentFilterEnvioAduana.IdEstadoEnvioAduanas > 0 ||
            this.envioAduanasService.currentFilterEnvioAduana.IdSolicitud > 0 ||
            this.envioAduanasService.currentFilterEnvioAduana.CodigoSolicitud != '' ||
            this.envioAduanasService.currentFilterEnvioAduana.CodigoTaric != '' ||
            this.envioAduanasService.currentFilterEnvioAduana.Nrc != '' ||
            this.envioAduanasService.currentFilterEnvioAduana.FechaDesde!.toString() != this.firstDayMonth.toString() ||
            this.envioAduanasService.currentFilterEnvioAduana.FechaHasta!.toString() != this.lastDayMonth.toString()
        ) {
            this.form.patchValue({
                IdSolicitud: this.envioAduanasService.currentFilterEnvioAduana.IdSolicitud,
                IdEstadoEnvioAduanas: this.envioAduanasService.currentFilterEnvioAduana.IdEstadoEnvioAduanas,
                CodigoSolicitud: this.envioAduanasService.currentFilterEnvioAduana.CodigoSolicitud,
                CodigoTaric: this.envioAduanasService.currentFilterEnvioAduana.CodigoTaric,
                Nrc: this.envioAduanasService.currentFilterEnvioAduana.Nrc,
                FechaDesde: this.envioAduanasService.currentFilterEnvioAduana.FechaDesde,
                FechaHasta: this.envioAduanasService.currentFilterEnvioAduana.FechaHasta,
            });

            this.onSearchButton();
        }
    }

    onSearchButton() {
        if (this.turboTable) {
            this.turboTable.first = 0;
        }

        this.Search(0);

        this.envioAduanasService.currentFilterEnvioAduana.IdSolicitud = this.form.value.IdSolicitud;
        this.envioAduanasService.currentFilterEnvioAduana.IdEstadoEnvioAduanas = this.form.value.IdEstadoEnvioAduanas;
        this.envioAduanasService.currentFilterEnvioAduana.CodigoSolicitud = this.form.value.CodigoSolicitud;
        this.envioAduanasService.currentFilterEnvioAduana.CodigoTaric = this.form.value.CodigoTaric;
        this.envioAduanasService.currentFilterEnvioAduana.Nrc = this.form.value.Nrc;
        this.envioAduanasService.currentFilterEnvioAduana.FechaDesde = this.form.value.FechaDesde;
        this.envioAduanasService.currentFilterEnvioAduana.FechaHasta = this.form.value.FechaHasta;

        this.searchingButton = true;
        this.isCollapsed = true;
    }

    getFechaHasta(): Date {
        (this.form.value.FechaHasta as Date).setHours(23);
        (this.form.value.FechaHasta as Date).setMinutes(59);
        (this.form.value.FechaHasta as Date).setSeconds(59);

        return this.form.value.FechaHasta as Date;
    }

    Search(pageNumber: number, asc = -1, orderBy = 'FechaEnvio') {
        let params = new HttpParams();

        //La columna del grid "Fecha Envío" está mostrando el campo FechaCompleta que es de tipo varchar en
        //la vista V_ENVIO_ADUANAS_EXTENDED, así­ conseguimos mostrar la hora y que también la exportación a
        //Excel funcione bien. Si el usuario quiere ordenar por esta columna en el grid, le enchufamos realmente
        //la columna FechaEnvio que es de tipo Datetime para que funcione correctamente.
        if (orderBy == 'FechaCompleta') {
            orderBy = 'FechaEnvio'; //no es necesario que esté en el filtro del cliente, pero sí­ en el del servidor
        }

        if (orderBy == 'FechaInicioCompleta') {
            orderBy = 'FechaInicio'; //no es necesario que esté en el filtro del cliente, pero sí­ en el del servidor
        }

        params = params.append('pageNumber', pageNumber.toString());
        params = params.append('asc', asc.toString());
        params = params.append('orderBy', orderBy);
        params = params.append('IdSolicitud', this.form.value.IdSolicitud);
        params = params.append('IdEstadoEnvioAduanas', this.form.value.IdEstadoEnvioAduanas);
        params = params.append('CodigoSolicitud', this.form.value.CodigoSolicitud);
        params = params.append('CodigoTaric', this.form.value.CodigoTaric);
        params = params.append('Nrc', this.form.value.Nrc);
        params = params.append('FechaDesde', this.form.value.FechaDesde != null ? this.form.value.FechaDesde.toDateString() : '');
        params = params.append('FechaHasta', this.form.value.FechaHasta != null ? this.getFechaHasta().toLocaleString('es-ES', { hour12: false }) : '');

        this.loading = true;
        this.envioAduanasService.getEnvioAduanasPagedByFilter(params).subscribe(result => {
            this.resultEnvioAduanas = result;
            this.loading = false;
        });
    }

    onSearchLazy(event: any) {
        if (!event.rows || event.sortField == 'Link') {
            return;
        }

        let pageNumber = event.first / event.rows;
        this.Search(pageNumber, event.sortOrder, event.sortField);
    }

    onCleanButton() {
        this.form.setValue({
            IdSolicitud: null,
            CodigoSolicitud: '',
            CodigoTaric: '',
            IdEstadoEnvioAduanas: null,
            Nrc: '',
            FechaDesde: this.firstDayMonth,
            FechaHasta: this.lastDayMonth,
        });

        this.searchingButton = false;
        this.isCollapsed = false;
    }

    onDelete(item: EnvioAduanasItemViewModel) {
        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.envioAduanasService.deleteEnvioAduana(item.IdEnvio).subscribe(() => {
                    this.addSuccessMessage('Envío Aduanas eliminado correctamente');
                    this.onSearchButton();
                });
            },
        });
    }

    onView(item: EnvioAduanasItemViewModel) {
        this.router.navigate(['/mantenimiento/envios/aduanasv2/edit', item.IdEnvio]);
    }

    CreateModel() {
        let model: EnvioAduanasViewModel = new EnvioAduanasViewModel();

        Object.assign(model, this.form.value);

        model.FechaHasta = this.form.value.FechaHasta != null ? this.getFechaHasta() : this.form.value.FechaHasta;

        return model;
    }

    onExportExcel() {
        this.visibilitySpinner = true;

        this.envioAduanasService.export(this.CreateModel()).subscribe(res => {
            this.OpenDownloadedFile(res);
            this.visibilitySpinner = false;
        });
    }
}
